<template>
    <div class="wrap">
        <!-- <div class="title">{{ title }}</div>
        <div class="titleTime">{{ time }}</div>
        <div class="line"></div> -->
        <div class="first">一、策略构造逻辑</div>
        <div class="paragraph">
            该策略通过多因子复合筛选，在中证转债指数成分债中，优选低估值、低隐含波动率水平的转债，同时结合转债的股性水平和纯债价值保护等构建投资组合，实现稳健收益。
        </div>
        <div class="first">二、选择因子组合</div>
        <div class="paragraph">1、低BS定价溢价率（市场估值类）：代表转债的价值被低估，未来具有估值修复的机会；</div>
        <div class="paragraph">2、低隐含波动率（市场估值类）：意味着市场对正股未来波动的预期处于低位，这类转债可能隐藏着正股反转的投资机会；</div>
        <div class="paragraph">3、可转债-正股涨幅相关性（量价类因子）：可转债与正股涨幅相关性高，代表转债的股性强；</div>
        <div class="paragraph">4、低修正转股溢价率（市场估值类）：代表转债的股性较强，当正股价格上涨时，转债内含的转股价值能够有效提升转债的价值，反映到转债价格上可以较好地跟随正股上涨；</div>
        <div class="paragraph">5、即期收益率（市场估值类）：高即期收益率往往对应低价转债，有纯债价值支撑，下跌空间有限。</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片1.png')"></BaseBigimg>
        </div>
        <div class="paragraph">策略回测结果：</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片2.png')"></BaseBigimg>
        </div>
        <div class="first">三、结论</div>
        <div class="paragraph">
            综上所述，运用<common-data name="appShortName_37"/>构建策略，用户可以优选低估值、低隐含波动率水平的转债，同时结合转债的股性水平和纯债价值保护等构建投资组合，帮助用户提前占据领先地位、获取更高收益。
        </div>

         <div style="height:20px"></div>
            <note></note>
            <div style="height:25px"></div>
        </div>
</template>
<script>
    import note from '../note.vue'
    export default {
        components:{
            note
        }
    };
</script>
<style scoped src="../common.css"></style>
